export * from './sGKB986A.service';
import { SGKB986AService } from './sGKB986A.service';
export * from './sZMA102A.service';
import { SZMA102AService } from './sZMA102A.service';
export * from './sZMA103A.service';
import { SZMA103AService } from './sZMA103A.service';
export * from './sZMA202A.service';
import { SZMA202AService } from './sZMA202A.service';
export * from './sZMA301A.service';
import { SZMA301AService } from './sZMA301A.service';
export * from './sZOA206A.service';
import { SZOA206AService } from './sZOA206A.service';
export * from './sZOA304A.service';
import { SZOA304AService } from './sZOA304A.service';
export * from './sZOA308A.service';
import { SZOA308AService } from './sZOA308A.service';
export * from './sGKB702A.service';
import { SGKB702AService } from './sGKB702A.service';
export * from './sGKB709A.service';
import { SGKB709AService } from './sGKB709A.service';
export * from './sGKB981A.service';
import { SGKB981AService } from './sGKB981A.service';
export * from './sGKB983A.service';
import { SGKB983AService } from './sGKB983A.service';
export * from './sGKB575A.service';
import { SGKB575AService } from './sGKB575A.service';
export * from './sGKD036A.service';
import { SGKD036AService } from './sGKD036A.service';
export * from './sZOA104A.service';
import { SZOA104AService } from './sZOA104A.service';
export * from './sZOA109A.service';
import { SZOA109AService } from './sZOA109A.service';
export * from './sZOA110A.service';
import { SZOA110AService } from './sZOA110A.service';
export * from './sZME004A.service';
import { SZME004AService } from './sZME004A.service';
export * from './sGKB502A.service';
import { SGKB502AService } from './sGKB502A.service';
export * from './sGKB121A.service';
import { SGKB121AService } from './sGKB121A.service';
export * from './sGKB991A.service';
import { SGKB991AService } from './sGKB991A.service';
export * from './sGKB992A.service';
import { SGKB992AService } from './sGKB992A.service';



export const APIS_SGKB = [SGKB986AService, SZMA102AService, SZMA103AService, SZMA202AService, SZMA301AService, SZOA206AService, SZOA304AService, SZOA308AService, SGKB702AService, SGKB709AService, SGKB981AService, SGKB983AService, SGKB575AService, SGKD036AService, SZOA104AService, SZOA109AService, SZOA110AService, SZME004AService, SGKB502AService, SGKB121AService, SGKB991AService, SGKB992AService];
